import { pickBy } from '@/utils'
import CouponStyle from './coupon-style'
import CouponItem from './coupon-item'
import CouponPackage from './coupon-package'

export default {
  name: 'coupon',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '到店優惠' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '遊客專享福利' },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    // {
    //   label: '樣式',
    //   key: 'style',
    //   component: function (h, { key }) {
    //     return <CouponStyle v-model={this.value[key]} />
    //   },
    //   value: '1'
    // },
    {
      label: '優惠券',
      key: 'data',
      component: function (h, { key }) {
        return <CouponItem v-model={this.value[key]} />
      },
      value: [
        {
          amount: 8,
          desc: '優惠券描述',
          id: '',
          imgUrl: '',
          title: '優惠券名稱',
          type: 'cash'
        }
      ]
    },
    {
      label: '券包',
      key: 'voucher_package',
      component: function (h, { key }) {
        return <CouponPackage v-model={this.value[key]} />
      },
      value: [],
      tip: `提示: 優惠券、券包顏色跟隨商城主題色變化<br />
      建議尺寸:<br />
      一張圖片（寬度355px，高度90px）<br />
      二張圖片（寬度172px，高度90px）<br />
      三張圖片或更多（寬度138px，高度90px）`
    }
  ],
  transformIn: (v) => {
    const { name, base, data, voucher_package } = v
    return {
      name,
      ...base,
      data,
      voucher_package
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      data: 'data',
      voucher_package: 'voucher_package'
    })
  }
}
